import React from "react";

import { Box } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import { makeStyles, fade, useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	card: {
		display: "flex",
		alignItems: "center",
		gap: 14,
		padding: "14px 16px",
		borderRadius: 10,
		background: theme.palette.type === "dark" ? "#2a2f36" : "#ffffff",
		boxShadow: theme.palette.type === "dark"
			? "0 1px 3px rgba(0,0,0,0.4)"
			: "0 1px 3px rgba(15,23,42,0.08)",
		borderLeft: props => `4px solid ${props.color}`,
		minHeight: 82,
	},
	iconWrap: {
		width: 42,
		height: 42,
		minWidth: 42,
		borderRadius: 10,
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		fontSize: 22,
		color: props => props.color,
		background: props => fade(props.color, theme.palette.type === "dark" ? 0.18 : 0.12),
	},
	textWrap: {
		minWidth: 0,
	},
	label: {
		fontSize: 12,
		fontWeight: 600,
		letterSpacing: 0.2,
		color: theme.palette.type === "dark" ? "#9aa5b1" : "#64748b",
		textTransform: "uppercase",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
	value: {
		fontSize: 24,
		fontWeight: 700,
		lineHeight: 1.25,
		color: theme.palette.type === "dark" ? "#f1f5f9" : "#1e293b",
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},
}));

export default function CardCounter(props) {
	const { icon, title, value, loading, color } = props;
	const theme = useTheme();
	const resolvedColor = color || theme.palette.primary.main;
	const classes = useStyles({ color: resolvedColor });

	if (loading) {
		return <Skeleton variant="rect" height={82} style={{ borderRadius: 10 }} />;
	}

	return (
		<Box className={classes.card}>
			{icon && <div className={classes.iconWrap}>{icon}</div>}
			<div className={classes.textWrap}>
				<div className={classes.label}>{title}</div>
				<div className={classes.value}>{value}</div>
			</div>
		</Box>
	);
}
